"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/jsx-props-no-spreading */
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var AuthenticationService_1 = require("./AuthenticationService");
var EnumRole_1 = require("./EnumRole");
;
exports.mapStateToProps = function (state) { return ({
    authenticatedUser: state.authentication.user
}); };
var connector = react_redux_1.connect(exports.mapStateToProps);
var SecuredRoute = function (props) {
    var requiredRoles = props.requiredRoles, authenticatedUser = props.authenticatedUser, render = props.render, profileCondtion = props.profileCondtion;
    var useRoles = AuthenticationService_1.AuthenticationService.getUserRoles(authenticatedUser);
    var isAllowedByRoles = (requiredRoles && requiredRoles.length > 0) ? (requiredRoles.filter(function (value) { return useRoles.includes(value); }).length >
        0 || requiredRoles.indexOf(EnumRole_1.UserRole.All) !== -1 || requiredRoles.indexOf(EnumRole_1.UserRole.None) !== -1) : true;
    var isAllowedByProfileCondition = profileCondtion ? profileCondtion(authenticatedUser) : true;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_router_dom_1.Route, __assign({}, props, { render: (authenticatedUser && isAllowedByRoles && isAllowedByProfileCondition) ? render : (function () {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_router_dom_1.Redirect, { to: '/error/403' })));
            }) }))));
};
exports.default = connector(SecuredRoute);
//# sourceMappingURL=SecuredRoute.js.map